import React, { useState } from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import type { AudioFeature } from '../../../types/audioFeature';

import { AudioFeatureToggle } from './AudioFeatureToggle';
import { AudioHeader } from './AudioHeader';

export type AudioHeaderPanelProps = {
	featureList: [AudioFeature, AudioFeature, ...AudioFeature[]];
};

export const AudioHeaderPanel = ({ featureList }: AudioHeaderPanelProps) => {
	// Placeholder until platform state hook is implemented
	const [activeFeatureIndex, setActiveFeatureIndex] = useState(0);

	const getNextFeatureIndex = () => {
		return (activeFeatureIndex + 1) % featureList.length;
	};

	return (
		<Stack space="space.250" alignInline="center">
			<AudioHeader featureList={featureList} activeFeatureIndex={activeFeatureIndex} />
			<AudioFeatureToggle
				featureList={featureList}
				activeFeatureIndex={activeFeatureIndex}
				onClick={() => setActiveFeatureIndex(getNextFeatureIndex)}
			/>
		</Stack>
	);
};
